







































import { defineComponent, useContext } from '@nuxtjs/composition-api'
import { PropType } from 'vue';
import HTMLContent from '~/components/solepro/HTMLContent.vue';
import { ProductForProductPageType } from '~/utils/types/ProductPage';
import { formatDate } from "~/utils/helpers/functions";

export default defineComponent({
    props: {
        product: {
            type: Object as PropType<ProductForProductPageType>
        }
    },
    components: {
        HTMLContent
    },
    setup(props) {
        const { $fc } = useContext();
        const attributes = [
            ...(props.product.area_funzionalita ? [{
                label: 'Autore',
                value: props.product.autore
            }] : [{}]),
            {
                label: 'Numero di pagine',
                value: props.product.pages
            },
            {
                label: 'Prezzo di copertina',
                value: !!props.product.coverPrice ? $fc(props.product.coverPrice) : null
            },
            {
                label: 'Prezzo PDF',
                value: !!props.product.pdfPrice ? $fc(props.product.pdfPrice) : null
            },
            {
                label: 'Pubblicazione',
                value: formatDate(props.product.published)
            },
            {
                label: 'Codice ISBN',
                value: props.product.codice_isbn
            },
            {
                label: 'Codice ISBN Digitale',
                value: props.product.codice_isbn_digitale
            }
        ]
        return {
            attributes,
            autoriList: props.product.autore ? props.product.autore.split(',') : []
        }
    },
})
